import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../AuthContext";
import { Badge } from "../Badge";
import { LogOut } from "lucide-react";

export default function CaregiverProfile() {
  const [data, setData] = useState(null);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/caregiver/profile").then((r) => setData(r.data)).catch(() => setData(false));
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    navigate("/caregiver/login");
  };

  if (data === null) return <p className="text-slate-500 font-semibold">Loading profile…</p>;
  if (data === false) return <p className="text-red-700 font-semibold">Unable to load your profile.</p>;

  const cg = data.caregiver;

  return (
    <div data-testid="caregiver-profile" className="max-w-2xl">
      <h1 className="font-display text-3xl md:text-4xl text-brand-navy">My Profile</h1>
      <p className="mt-2 text-[15px] text-slate-600">Your caregiver account details. Contact the office to update your information.</p>

      <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <h2 className="font-display text-2xl text-brand-navy">{cg.name}</h2>
          <Badge kind="caregiver" value={cg.status} />
        </div>
        <div className="mt-6 space-y-4 text-[15px]">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Email</p>
            <p className="mt-1 text-brand-navy font-medium">{cg.email}</p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Phone</p>
            <p className="mt-1 text-brand-navy font-medium">{cg.phone || "—"}</p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Availability</p>
            <p className="mt-1 text-brand-navy font-medium">{cg.availability || "—"}</p>
          </div>
        </div>
      </section>

      <button
        onClick={logout}
        data-testid="profile-logout"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-navy px-6 py-3 text-[15px] font-bold text-white hover:bg-brand-teal transition-colors duration-300 active:scale-95"
      >
        <LogOut className="h-4 w-4" strokeWidth={1.8} />
        Log Out
      </button>
    </div>
  );
}
